import LegalPageLayout from '../components/LegalPageLayout';

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section className="space-y-4">
      <h2 className="text-xl font-semibold text-gray-900">{title}</h2>
      <div className="space-y-4 text-sm leading-7 text-gray-600">{children}</div>
    </section>
  );
}

export default function ServiceDisclosures() {
  return (
    <LegalPageLayout
      title="Important Service Disclosures"
      subtitle="A plain-English summary of what Filie does today, what it does not do yet, and how beta users should use the product."
      lastUpdated="April 13, 2026"
    >
      <Section title="What Filie Does Today">
        <ul className="list-disc space-y-2 pl-6">
          <li>Accepts uploads of common federal tax forms such as W-2s and 1099s.</li>
          <li>Uses AI to classify forms and extract tax-relevant fields.</li>
          <li>Uses Filie&apos;s deterministic engine to compute federal tax values.</li>
          <li>Shows you where values came from and flags lower-confidence extractions for review.</li>
          <li>Generates plain-language summaries and draft federal forms.</li>
        </ul>
      </Section>

      <Section title="What Filie Does Not Yet Do">
        <ul className="list-disc space-y-2 pl-6">
          <li>Filie does not currently provide state or local return preparation.</li>
          <li>Filie does not currently submit electronic filings to the IRS or to states.</li>
          <li>Filie may not support every form, schedule, or tax edge case.</li>
          <li>Filie is not a substitute for individualized legal, tax, or accounting advice.</li>
        </ul>
      </Section>

      <Section title="How to Use Filie Safely">
        <ul className="list-disc space-y-2 pl-6">
          <li>Review extracted values before relying on a result.</li>
          <li>Confirm filing status, tax year, spouse assignment, and major income totals.</li>
          <li>Use the issue-reporting flow if something looks missing, wrong, or confusing.</li>
          <li>If you need state returns, e-file, or professional advice, plan for that separately.</li>
        </ul>
      </Section>

      <Section title="Handling of Sensitive Data">
        <p>
          Filie&apos;s current pipeline is designed to redact Social Security numbers and EINs from images before those
          images are sent to an external AI provider. Documents are stored using production storage controls, and
          application monitoring is configured to avoid sending document contents to error telemetry where possible.
        </p>
      </Section>

      <Section title="Questions">
        <p>
          For support, privacy questions, or beta issues, email
          {' '}<a className="text-gray-900 underline" href="mailto:support@filie.ai">support@filie.ai</a>.
        </p>
      </Section>
    </LegalPageLayout>
  );
}
